<template>
  <div class="edit-main">
    <div class="page-contain edit-meeting-plan">
        <el-form :model="addNewOrEditData" :show-message="false" ref="form" label-position="top">
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row>
                        <el-col>
                            <el-form-item required label="会议名称" prop="meetingName">
                                <el-input :maxlength="50" v-model="addNewOrEditData.meetingName" placeholder="请输入会议名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required prop="meetingSystem">
                                <span class="tooltip-header-text" slot="label">系统选择<common-tooltip tipCode="8"></common-tooltip></span>
                                <el-select multiple clearable placeholder="请选择（可多选）" v-model="addNewOrEditData.meetingSystem">
                                    <el-option v-for="item in baseDataRecords.MeetingSystem" :key="item.value" :value="item.value" :label="item.text">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="是否网络会议" prop="meetingModality">
                                <el-select clearable placeholder="请选择" v-model="addNewOrEditData.meetingModality">
                                    <el-option v-for="item in baseDataRecords.MeetingModality" :key="item.value" :value="item.value" :label="item.text">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item required label="会议性质" prop="meetingProp">
                                <el-select @change="handleMeetingPropChange" clearable placeholder="请选择" v-model="addNewOrEditData.meetingProp">
                                    <el-option v-for="item in meetingPropAndTypeArrays.selectMeetingProp" :key="item.itemValue" :value="item.itemValue" :label="item.itemText">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="meetingSystemType != 'GSD'">
                            <el-form-item required label="A1会议类型" prop="meetingType">
                                <el-select @change="handleMeetingTypeChange" clearable placeholder="请选择" v-model="addNewOrEditData.meetingType">
                                    <el-option v-for="item in filterMeetingType" :key="item.itemValue" :value="item.itemValue" :label="item.itemText">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="addNewOrEditData.meetingType === '24' && isCEDepart()">
                          <el-form-item required label="是否为GSD" prop="isGsd">
                            <el-radio-group v-model="addNewOrEditData.isGsd">
                              <el-radio :label="1">是</el-radio>
                              <el-radio :label="0">否</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="meetingSystemType != 'A1'">
                        <el-col>
                            <el-form-item required label="GSD项目类型" prop="meetingGsdType">
                                <el-select @change="addNewOrEditData.meetingGsdSubType = ''" clearable placeholder="请选择" v-model="addNewOrEditData.meetingGsdType">
                                    <el-option v-for="item in baseDataRecords.MeetingGsdType" :key="item.value" :value="item.value" :label="item.text">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="GSD细类" prop="meetingGsdSubType">
                                <el-select clearable placeholder="请选择" v-model="addNewOrEditData.meetingGsdSubType">
                                    <el-option v-for="item in MeetingGsdSubTypes" :key="item.value" :value="item.value" :label="item.text">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row>
                        <el-col>
                            <el-form-item required label="部门" prop="departId">
                                <el-select @change="handleDepartChange" clearable placeholder="请选择" v-model="addNewOrEditData.departId">
                                    <el-option v-for="item in baseDataRecords.Depart" :key="item.id" :value="item.id" :label="item.departName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="Franchise/DA" prop="medicalField">
                                <el-select @change="addNewOrEditData.teamL4 = '';resetRelativeFields()" clearable placeholder="请选择" v-model="addNewOrEditData.medicalField">
                                    <el-option v-for="item in getMedicalFieldArray(addNewOrEditData.departId, false)" :key="item.id" :value="item.id" :label="item.medicalFieldName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="团队" prop="teamL4">
                                <el-select @change="resetRelativeFields" clearable placeholder="请选择" v-model="addNewOrEditData.teamL4">
                                    <el-option v-for="item in getTeamArray(addNewOrEditData.departId, addNewOrEditData.medicalField, false)" :key="item.id" :value="item.id" :label="item.teamName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col v-if="basedataGetName('MeetingProp',addNewOrEditData.meetingProp) == '推广'">
                            <el-form-item required label="治疗领域" prop="treatmentArea">
                                <el-select @change="handleAreaChange()" filterable clearable placeholder="请选择（可搜索）" v-model="addNewOrEditData.treatmentArea">
                                    <el-option v-for="item in areaRelationObject[addNewOrEditData.meetingProp]" :key="item.areaDbId" :value="item.areaDbId" :label="item.areaName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="basedataGetName('MeetingProp',addNewOrEditData.meetingProp).indexOf('非推广') >= 0">
                            <el-form-item required label="疾病领域" prop="diseaseArea">
                                <el-select @change="handleAreaChange()" filterable clearable placeholder="请选择（可搜索）" v-model="addNewOrEditData.diseaseArea">
                                    <el-option v-for="item in areaRelationObject[addNewOrEditData.meetingProp]" :key="item.areaDbId" :value="item.areaDbId" :label="item.areaName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="产品" prop="productId">
                                <el-select filterable @change="resetRelativeFields" multiple clearable placeholder="请选择（可多选，可搜索）" v-model="addNewOrEditData.productId">
                                    <el-option v-for="item in productArray" :key="item.productDbId" :value="item.productDbId" :label="item.productName">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="公司战略" prop="companyStrategy">
                                <el-select multiple clearable placeholder="请选择（可多选）" v-model="addNewOrEditData.companyStrategy">
                                    <el-option v-for="item in baseDataRecords.CompanyStrategy" :key="item.value" :value="item.value" :label="item.text">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item required label="策略重点" prop="strategyKeynote">
                                <el-select filterable multiple clearable placeholder="请选择（可多选，可搜索）" v-model="addNewOrEditData.strategyKeynote">
                                    <el-option v-for="item in filterStrategy" :key="item.id" :value="item.id" :label="`${item.productName} - ${item.keynote}`">
                                    </el-option>
                                    <el-option value="999999" label="其他/不适用"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'A1'" label="治疗领域业务结果" prop="medicalFieldResult">
                                <el-select filterable multiple clearable placeholder="请选择（可多选，可搜索）" v-model="addNewOrEditData.medicalFieldResult">
                                    <el-option v-for="item in filterDomainResult" :key="item.id" :value="item.id" :label="`${item.productName} - ${item.treatAreaResult}`">
                                    </el-option>
                                    <el-option value="999999" label="其他"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') >= 0">
                            <el-form-item class="medicalFieldResultDesItem" label="治疗领域业务结果（自定义描述）" prop="medicalFieldResultDes">
                                <el-input class="medicalFieldResultDes" rows="1" maxlength="200" type="textarea" v-model="addNewOrEditData.medicalFieldResultDes" placeholder="请输入业务结果描述"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row>
                        <el-col>
                            <el-form-item required label="开始日期" prop="meetingBeginDate">
                                <el-date-picker :default-value="seasonStartDate" :picker-options="startPickerOptions" type="date" v-model="addNewOrEditData.meetingBeginDate" placeholder="请选择" ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="结束日期" prop="meetingEndDate">
                                <el-date-picker :default-value="addNewOrEditData.meetingBeginDate" :picker-options="endPickerOptions" type="date" v-model="addNewOrEditData.meetingEndDate" placeholder="请选择" ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" label="会议时段" prop="meetingTimeInt">
                                <el-select placeholder="请选择" v-model="addNewOrEditData.meetingTimeInt">
                                    <el-option v-for="item in baseDataRecords.MeetingTimeInt" :key="item.value" :value="item.value" :label="item.text">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" label="国家" prop="country">
                                <el-select @change="handleCountryChange" clearable placeholder="请选择" v-model="addNewOrEditData.country">
                                    <el-option v-for="item in baseDataRecords.Country" :key="item.id" :value="item.id" :label="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" label="省份" prop="province">
                                <el-select @change="handleProvinceChange" clearable placeholder="请先选择国家" v-model="addNewOrEditData.province">
                                    <el-option v-for="item in remoteProvinceData" :key="item.id" :value="item.id" :label="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" label="城市" prop="city">
                                <el-select @change="addNewOrEditData.cityName = getName(addNewOrEditData.city, remoteCitiesData, 'id', 'name');clearHospital()" clearable placeholder="请先选择省份" v-model="addNewOrEditData.city">
                                    <el-option v-for="item in remoteCitiesData" :key="item.id" :value="item.id" :label="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD' && basedataGetName('MeetingModality',addNewOrEditData.meetingModality).indexOf('线下') >= 0" label="会议地点" prop="meetingPlace">
                                <el-input :maxlength="50" v-model="addNewOrEditData.meetingPlace" placeholder="请输入会议地点"></el-input>
                                <div class="meeting-place-tip">原则上，不得在餐厅或酒吧等以餐饮、休闲娱乐为主要目的的场所举办学术会议。</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row v-if="meetingSystemType != 'A1'">
                        <div class="col-full">
                            <el-form-item required label="受赠方类型(GSD系统)">
                                <el-radio-group v-model="recipientSocietyOrHospital">
                                    <el-radio :label="1" class="tooltip-header-text">受赠学会<common-tooltip tipCode="11"></common-tooltip></el-radio>
                                    <el-radio :label="0">医院</el-radio>
                                    <el-radio :label="2">大学</el-radio>
                                    <el-radio :label="3">患者组织</el-radio>
                                    <el-radio :label="4">其他</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </el-row>
                    <el-row class="recipientSociety-input" v-if="meetingSystemType != 'A1' && recipientSocietyOrHospital">
                        <el-col>
                            <el-form-item v-if="recipientSocietyOrHospital == 1" prop="recipientSocietyStr">
                                <el-input v-model="addNewOrEditData.recipientSocietyStr" placeholder="请输入学会名称(必填)"></el-input>
                            </el-form-item>
                            <el-form-item v-if="recipientSocietyOrHospital == 2" prop="universityStr">
                                <el-input v-model="addNewOrEditData.universityStr" placeholder="请输入大学名称(必填)"></el-input>
                            </el-form-item>
                            <el-form-item v-if="recipientSocietyOrHospital == 3" prop="patientOrgStr">
                                <el-input v-model="addNewOrEditData.patientOrgStr" placeholder="请输入患者组织名称(必填)"></el-input>
                            </el-form-item>
                            <el-form-item v-if="recipientSocietyOrHospital == 4" prop="otherStr">
                                <el-input v-model="addNewOrEditData.otherStr" placeholder="请输入其他名称(必填)"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <div v-if="meetingSystemType == 'A1' || !recipientSocietyOrHospital">
                        <el-row>
                            <el-col v-if="!isOneHospital()">
                                <el-form-item required label="医院总数">
                                    <el-radio-group v-model="moreThenOneHospital">
                                        <el-radio :label="0">一家</el-radio>
                                        <el-radio :label="1">两家及以上</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row class="more-tab">
                            <el-col>
                                <el-form-item required prop="hospitalLevelId">
                                    <span class="tooltip-header-text" slot="label">医院层级<common-tooltip tipCode="9"></common-tooltip></span>
                                    <el-select clearable placeholder="请选择" v-model="addNewOrEditData.hospitalLevelId">
                                        <el-option v-for="item in filterHospitalLevel" :key="item.id" :value="item.id" :label="item.hospitalLevel" :disabled="item.typeId === disableHospitalType || isSelectedHospitalLevel(item.id)">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="moreThenOneHospital && !isOneHospital()" class="col-add-remove">
                                <el-form-item required label="医院数量" prop="hospitalCount">
                                    <el-input-number placeholder="请输入医院数量" :controls="false" :precision="0" :min="1" v-model="addNewOrEditData.hospitalCount"></el-input-number>
                                </el-form-item>
                                <div class="operate-add-remove">
                                    <i @click="AddNewHospitalInfo" class="iconfont icon-tianjia1"></i>
                                </div>
                            </el-col>
                            <el-col v-else>
                                <el-form-item required label="医院" prop="hospitalId">
                                    <el-select @change="addNewOrEditData.hospitalName = getName(addNewOrEditData.hospitalId, remoteHospitalData, 'id', 'hospitalName'); " @focus="remoteHospitalData=[];" @blur="remoteHospitalData = remoteHospitalDataTemp" filterable remote :remote-method="handleHospitalFilter" clearable :placeholder="(isOneHospital() && !addNewOrEditData.cityName)?'请先选择城市':'请输入'" v-model="addNewOrEditData.hospitalId">
                                        <el-option v-for="item in remoteHospitalData" :key="item.id" :value="item.id" :label="item.hospitalName">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div v-if="moreThenOneHospital && !isOneHospital()">
                            <div class="more-tab-div" v-for="(hospital,index) in addNewOrEditData.extendData.hospitalInfos" :key="index">
                                <el-row class="more-tab">
                                    <el-col>
                                        <el-form-item required :prop="'extendData.hospitalInfos.'+index+'.hospitalLevelId'">
                                            <span class="tooltip-header-text" slot="label">医院层级<common-tooltip tipCode="9"></common-tooltip></span>
                                            <el-select clearable placeholder="请选择" v-model="hospital.hospitalLevelId">
                                                <el-option v-for="item in filterHospitalLevel" :key="item.id" :value="item.id" :label="item.hospitalLevel" :disabled="item.typeId === disableHospitalType || isSelectedHospitalLevel(item.id)">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col class="col-add-remove">
                                        <el-form-item required label="医院数量" :prop="'extendData.hospitalInfos.'+index+'.hospitalCount'">
                                            <el-input-number placeholder="请输入医院数量" :controls="false" :precision="0" :min="0" v-model="hospital.hospitalCount"></el-input-number>
                                        </el-form-item>
                                        <div class="operate-add-remove">
                                            <i @click="AddNewHospitalInfo" class="iconfont icon-tianjia1"></i>
                                            <i @click="removeHosiptalInfo(index)" class="iconfont icon-shanjian"></i>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <el-row>
                            <el-col>
                                <el-form-item :required="meetingSystemType != 'GSD'" label="科室" prop="offices">
                                    <el-select filterable multiple clearable placeholder="请选择（可多选，可搜索）" v-model="addNewOrEditData.offices">
                                        <el-option v-for="item in baseDataRecords.Office" :key="item.id" :value="item.id" :label="item.officeName">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row>
                        <el-col>
                            <el-form-item required label="是否包含讲者"  prop="includeSpeaker">
                                <el-radio-group v-model="addNewOrEditData.includeSpeaker">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="0">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row class="more-tab" v-if="addNewOrEditData.includeSpeaker == 1">
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" prop="speakerLevel">
                                <span class="tooltip-header-text" slot="label">讲者级别<common-tooltip tipCode="10"></common-tooltip></span>
                                <el-select clearable placeholder="请选择" v-model="addNewOrEditData.speakerLevel">
                                    <el-option v-for="item in filterSpeakerLevel" :key="item.id" :value="item.id" :label="item.speakerLevel" :disabled="item.typeId === disableSpeakerType || isSelectedSpeakerLevel(item.id)">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col class="col-add-remove">
                            <el-form-item :required="meetingSystemType != 'GSD'" label="讲者人数" prop="speakerCount">
                                <el-input-number placeholder="请输入讲者人数" :controls="false" :precision="0" :min="0" v-model="addNewOrEditData.speakerCount"></el-input-number>
                            </el-form-item>
                            <div class="operate-add-remove">
                                <i @click="AddNewSpeakerInfo" class="iconfont icon-tianjia1"></i>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="more-tab-div" v-if="addNewOrEditData.includeSpeaker == 1">
                        <el-row class="more-tab" v-for="(speaker,index) in addNewOrEditData.extendData.speakerInfos" :key="index">
                            <el-col>
                                <el-form-item :required="meetingSystemType != 'GSD'" :prop="'extendData.speakerInfos.'+index+'.speakerLevel'">
                                    <span class="tooltip-header-text" slot="label">讲者级别<common-tooltip tipCode="10"></common-tooltip></span>
                                    <el-select clearable placeholder="请选择" v-model="speaker.speakerLevel">
                                        <el-option v-for="item in filterSpeakerLevel" :key="item.id" :value="item.id" :label="item.speakerLevel" :disabled="item.typeId === disableSpeakerType || isSelectedSpeakerLevel(item.id)">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col class="col-add-remove">
                                <el-form-item :required="meetingSystemType != 'GSD'" label="讲者人数" :prop="'extendData.speakerInfos.'+index+'.speakerCount'">
                                    <el-input-number placeholder="请输入讲者人数" :controls="false" :precision="0" :min="0" v-model="speaker.speakerCount"></el-input-number>
                                </el-form-item>
                                <div class="operate-add-remove">
                                    <i @click="AddNewSpeakerInfo" class="iconfont icon-tianjia1"></i>
                                    <i @click="removeSpeakerInfo(index)" class="iconfont icon-shanjian"></i>
                                </div>
                            </el-col>
                    </el-row>
                   </div>
                    <el-row>
                        <el-col>
                            <el-form-item required label="参会人数（外）" prop="attendCount">
                                <el-input-number placeholder="请输入参会人数（外）" :controls="false" :precision="0" :min="0" v-model="addNewOrEditData.attendCount"></el-input-number>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item :required="meetingSystemType != 'GSD'" label="罗氏员工人数（内）" prop="rocheCount">
                                <el-input-number placeholder="请输入罗氏员工人数（内）" :controls="false" :precision="0" :min="0" v-model="addNewOrEditData.rocheCount"></el-input-number>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div class="page-contain-tab">
                <div class="content-box">
                    <el-row>
                        <el-col>
                            <el-form-item required prop="totalAmount">
                                <span class="tooltip-header-text" slot="label">会议总预算<common-tooltip :tipCode="disableTotalAmount ? 17 : 12"></common-tooltip></span>
                                <cny-input :disabled="disableTotalAmount" @blur="handleAmountCheck" :valueFixed="2" v-model="addNewOrEditData.totalAmount" placeholder="请输入"></cny-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item required label="类型" prop="costType">
                                <el-select @change="handleCostTypeChange" v-model="addNewOrEditData.costType">
                                    <!-- 修改这里：label是显示的文字，value是实际的值 -->
                                    <el-option :value="'1'" label="成本中心"></el-option>
                                    <el-option :value="'2'" label="Real Wbs Code"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="addNewOrEditData.costType == '2'">
                            <el-form-item required label="Real Wbs Code" prop="wbsCode">
                                <el-select clearable placeholder="请选择" v-model="addNewOrEditData.wbsCode">
                                    <el-option v-for="item in wbsCodeData" :key="item.costId" :value="item.costId" :label="item.costId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                        
                    <el-row>
                        <el-col class="cost-center-col" v-if="addNewOrEditData.costType == '1'">
                            <div v-if="isMeCostCenter && !currentUserSelectVisibled" @click.prevent="handlerUserCostCenterFieldClick" class="user-cost-center-field"><span class="user-cost-center-field-label">{{addNewOrEditData.costCenter+' '+getName(addNewOrEditData.costCenter, costCenterData, 'costCenter', 'costCenterName')}}</span><span class="current-user">本人</span></div>
                            <el-form-item required label="成本中心" prop="costCenter">
                                <el-select filterable @visible-change="handleCostCenterSelectVisibleChange" ref="costCenter" @change="handleCostCenterChange" clearable placeholder="请选择（可搜索）" v-model="addNewOrEditData.costCenter">
                                    <el-option class="edit-main-cost-center" v-for="(item,index) in costCenterData" :key="item.costCenter" :value="item.costCenter" :label="item.costCenter + ' ' + item.costCenterName">
                                        <span style="float: left">{{ item.costCenter + ' ' + item.costCenterName }}</span>
                                        <span v-if="item.isMe === '1'" class="current-user">本人</span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="addNewOrEditData.costType == '1'">
                            <el-form-item label="Statistical WBS code" prop="wbsCode">
                                <el-select clearable placeholder="请选择" v-model="addNewOrEditData.wbsCode">
                                    <el-option v-for="item in wbsCodeData" :key="item.costId" :value="item.costId" :label="item.costId">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col v-if="addNewOrEditData.meetingSystem.length == 2">
                            <el-form-item required label="A1预算" prop="a1Amount">
                                <cny-input @blur="handleAmountCheck" :valueFixed="2" v-model="addNewOrEditData.a1Amount" placeholder="请输入"></cny-input>
                            </el-form-item>
                        </el-col>
                        <el-col v-if="addNewOrEditData.meetingSystem.length == 2">
                            <el-form-item required label="GSD预算" prop="gsdAmount">
                                <cny-input @blur="handleAmountCheck" :valueFixed="2" v-model="addNewOrEditData.gsdAmount" placeholder="请输入"></cny-input>
                            </el-form-item>
                        </el-col>
                        <el-col>
                            <el-form-item label="会议申请人" prop="meetingOrganizerId">
                                <el-select @change="addNewOrEditData.meetingOrganizerName = getName(addNewOrEditData.meetingOrganizerId, remoteMeetingOrganizerData, 'Id', 'AD');addNewOrEditData.meetingOrganizerCnname = getName(addNewOrEditData.meetingOrganizerId, remoteMeetingOrganizerData, 'Id', 'CName'); remoteMeetingOrganizerData=[]"  filterable remote :remote-method="handleMeetingOrganizerFilter" clearable placeholder="请输入" v-model="addNewOrEditData.meetingOrganizerId">
                                    <el-option v-for="item in remoteMeetingOrganizerData" :key="item.Id" :value="item.Id" :label="item.CName+' '+item.AD">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </el-form>
    </div>
    <div class="bottom-info">
      <div class="bottom-info-operate" v-if="!waitBack">
        <el-button plain v-if="editType != 'edit'" @click="goBack()">删除</el-button>
        <el-button plain v-else @click="handleDeleteClick()">删除</el-button>
        <el-button type="primary" @click="handlerSave">保存</el-button>
      </div>
    </div>
    <!-- 确认保存 -->
    <common-confirm :dialogVisiable.sync="confirmSaveVisible" :confirm="handlerSaveConfirmOK">
        <div>
            确认保存会议？
        </div>
        <div v-if="isSeasonlyType">
            该季度的计划申请，需要直线经理和二级审批人审批
        </div>
        <div v-else>
            {{monthlyTypeMessage}}
        </div>
    </common-confirm>
    <!-- 确认删除 -->
    <common-confirm :dialogVisiable.sync="confirmDeleteVisible" :confirm="handlerDeleteConfirmOK">
        <div>
            确认删除会议？
        </div>
    </common-confirm>
  </div>
</template>

<script>
import costCenterAndWbs from '@/api/costCenterAndWbs';
import application from '@/api/meetingplan/application';
import privilege from '@/api/sysmanagement/privilege';
import basedata from '@/api/basedata';
import { mapGetters, mapActions } from 'vuex';
import utils from '@/util/utils';
import * as orgUtil from '@/util/organizationUtil'

export default {
  data() {
    return {
      addNewOrEditData: {
          costType: '1',
          meetingName: '',
          meetingType: '',
          meetingGsdType: '',
          isGsd: '',
          meetingGsdSubType: '',
          meetingProp: '',
          meetingModality: '',
          meetingSystem: [],
          departId: '',
          medicalField: '',
          teamL4: '',
          treatmentArea: '',
          diseaseArea: '',
          productId: [],
          companyStrategy: [],
          strategyKeynote: [],
          medicalFieldResult: [],
          medicalFieldResultDes: '',
          meetingBeginDate: '',
          meetingEndDate: '',
          meetingTimeInt: '',
          country: '',
          countryName: '',
          province: '',
          provinceName: '',
          city: '',
          cityName: '',
          meetingPlace: '',
          hospitalLevelId: '',
          hospitalCount: '',
          hospitalName: '',
          hospitalId: '',
          recipientSocietyStr: '',
          universityStr: '',
          patientOrgStr: '',
          otherStr: '',
          offices: [],
          speakerLevel: '',
          speakerCount: '',
          attendCount: '',
          rocheCount: '',
          totalAmount: '',
          costCenter: '',
          costCenterName: '',
          wbsCode: '',
          wbsCodeName: '',
          a1Amount: '',
          gsdAmount: '',
          meetingOrganizerId: '',
          meetingOrganizerName:'',
          meetingOrganizerCnname: '',
          includeSpeaker: '',
            extendData:{
                hospitalInfos: [],
                speakerInfos: [],
            },
      },
      startPickerOptions: {
        disabledDate: (time)=> {
            time = new Date(moment(time).format('YYYY-MM-DD'));
            if(this.seasonStartDate.getTime && time.getTime() < this.seasonStartDate.getTime()){
                return true;
            }

            if(this.seasonEndDate.getTime && time.getTime() > this.seasonEndDate.getTime()){
                return true;
            }

            if(!this.addNewOrEditData.meetingEndDate) {
              return false;
            }
            let endDate = new Date(moment(new Date(this.addNewOrEditData.meetingEndDate)).format('YYYY-MM-DD'));
            return time.getTime() > endDate.getTime();
          }
      },
      endPickerOptions: {
        disabledDate: (time)=> {
            time = new Date(moment(time).format('YYYY-MM-DD'));
            if(this.seasonStartDate.getTime && time.getTime() < this.seasonStartDate.getTime()){
                return true;
            }

            if(!this.addNewOrEditData.meetingBeginDate) {
              return false;
            }
            let startDate = new Date(moment(new Date(this.addNewOrEditData.meetingBeginDate)).format('YYYY-MM-DD'));
            return time.getTime() < startDate.getTime();
          }
      },
      remoteCitiesData: [],
      remoteProvinceData: [],
      remoteMeetingOrganizerData: [],
      remoteHospitalData: [],
      remoteHospitalDataTemp: [],
      seasonStartDate: '',
      seasonEndDate: '',
      confirmSaveVisible: false,
      confirmDeleteVisible: false,
      editType: '',
      strategyData: [],
      domainResultData: [],
      hospitalLevelData: [],
      speakerLevelData: [],
      speakerLevelDataObject: {},
      hospitalLevelDataObject: {},
      costCenterData: [],
      wbsCodeData: [],
      monthlyTypeMessage: '',
      recipientSocietyOrHospital: 1,
      moreThenOneHospital: 0,
      currentUserSelectVisibled: false,
      hiddenTime: null,
      meetingPropAndTypeArrays: {
        selectMeetingProp:[], //可选的会议性质
        popMeetingType:[], //推广的会议类型绑定
        nopopMeetingType: [], //非推广的会议类型绑定
        meetingPropType: [] //推广+非推广的会议类型绑定
      },
      waitBack: false,
      areaRelationObject: {
        '0': [],
        '1': [],
        '2': [],
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo','baseDataRecords','basedataGetName','basedataGetIdByName','basedataGetObject']),
    MeetingGsdSubTypes() {
        return this.baseDataRecords['MeetingGsdTypeSub'+this.addNewOrEditData.meetingGsdType] || [];
    },
    productArray() {
        if(!this.addNewOrEditData.meetingProp) {
            return []
        }

        let areaDbId = this.addNewOrEditData.diseaseArea;
        if(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp) == '推广') {
            areaDbId = this.addNewOrEditData.treatmentArea;
        }
        if(!areaDbId) {
            return []
        }

        let areaObject = this.areaRelationObject[this.addNewOrEditData.meetingProp].filter(a => a.areaDbId == areaDbId)[0];

        if(areaObject) {
            return areaObject.productArray;
        }
        else {
            return []
        }
    },
    filterMeetingType() {
        if(!this.addNewOrEditData.meetingProp) {
            return []
        }
        switch(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp)) {
            case '推广':
                return this.meetingPropAndTypeArrays.popMeetingType;
            case '非推广':
                return this.meetingPropAndTypeArrays.nopopMeetingType;
            default:
                return this.meetingPropAndTypeArrays.meetingPropType;
        }
    },
    disableSpeakerType() {
        let typeId = '';
        if(this.addNewOrEditData.speakerLevel) {
            typeId = this.speakerLevelDataObject[this.addNewOrEditData.speakerLevel].typeId;
        }
        else {
            for (let index = 0; index < this.addNewOrEditData.extendData.speakerInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.speakerInfos[index];
                if(element.speakerLevel) {
                    typeId = this.speakerLevelDataObject[element.speakerLevel].typeId;
                    break;
                }
            }
        }

        if(typeId === '0') {
            typeId = '1';
        }
        else if(typeId === '1') {
            typeId = '0';
        }

        return typeId;
    },
    disableHospitalType() {
        let typeId = '';
        if(this.addNewOrEditData.hospitalLevelId) {
            typeId = this.hospitalLevelDataObject[this.addNewOrEditData.hospitalLevelId].typeId;
        }
        else {
            for (let index = 0; index < this.addNewOrEditData.extendData.hospitalInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.hospitalInfos[index];
                if(element.hospitalLevelId) {
                    typeId = this.hospitalLevelDataObject[element.hospitalLevelId].typeId;
                    break;
                }
            }
        }

        if(typeId === '0') {
            typeId = '1';
        }
        else if(typeId === '1') {
            typeId = '0';
        }

        return typeId;
    },
    disableTotalAmount() {
      return false;
    //   return !!(this.addNewOrEditData.meetingType === '24' && this.isCEDepart());
    },
    meetingSystemType() {
        //GSD、A1、All、None
        if(this.addNewOrEditData.meetingSystem.length == 0) {
            return 'None';
        }
        if(this.addNewOrEditData.meetingSystem.length == 2) {
            return 'All';
        }
        if(this.addNewOrEditData.meetingSystem.length == 1) {
            return this.basedataGetName('MeetingSystem',this.addNewOrEditData.meetingSystem)
        }
    },
    filterStrategy() {
        let temp = [];
        let productIds = this.addNewOrEditData.productId.join(',');
        this.strategyData.forEach(strategy => {
            if(this.addNewOrEditData.departId && this.addNewOrEditData.departId != strategy.departId){
                return;
            }
            if(this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != strategy.medicalField){
                return;
            }
            if(this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != strategy.teamL4){
                return;
            }
            if(productIds && productIds.indexOf(strategy.productId) < 0){
                return;
            }

            temp.push(strategy);
        })

        return temp;
    },
    filterSpeakerLevel() {
        let temp = [];
        this.speakerLevelData.forEach(speaker => {
            if(speaker.typeId == '1') {
                if(speaker.departId && this.addNewOrEditData.departId && this.addNewOrEditData.departId != speaker.departId){
                    return;
                }
                if(speaker.medicalField && this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != speaker.medicalField){
                    return;
                }
                if(speaker.teamL4 && this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != speaker.teamL4){
                    return;
                }
            }

            temp.push(speaker);
        })

        return temp;
    },
    filterHospitalLevel() {
        let temp = [];
        let productIds = this.addNewOrEditData.productId.join(',');
        this.hospitalLevelData.forEach(hospital => {
            if(hospital.typeId == '1') {
                if(hospital.departId && this.addNewOrEditData.departId && this.addNewOrEditData.departId != hospital.departId){
                    return;
                }
                if(hospital.medicalField && this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != hospital.medicalField){
                    return;
                }
                if(hospital.teamL4 && this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != hospital.teamL4){
                    return;
                }
                if(hospital.prodIds && productIds){
                    if(!hospital.prodIds) {
                        return;
                    }
                    let hospitalProdIds = hospital.prodIds.split(',');
                    let match = false;
                    for (let index = 0; index < hospitalProdIds.length; index++) {
                        const element = hospitalProdIds[index];
                        if(productIds.indexOf(element) >= 0) {
                            match = true;
                            break;
                        }
                    }
                    if(!match){
                        return;
                    }
                }
            }

            temp.push(hospital);
        })

        return temp;
    },
    filterDomainResult() {
        let temp = [];
        let productIds = this.addNewOrEditData.productId.join(',');
        this.domainResultData.forEach(domainresult => {
            if(this.addNewOrEditData.departId && this.addNewOrEditData.departId != domainresult.departId){
                return;
            }
            if(this.addNewOrEditData.medicalField && this.addNewOrEditData.medicalField != domainresult.medicalField){
                return;
            }
            if(this.addNewOrEditData.teamL4 && this.addNewOrEditData.teamL4 != domainresult.teamL4){
                return;
            }
            if(productIds && productIds.indexOf(domainresult.productId) < 0){
                return;
            }

            temp.push(domainresult);
        })

        return temp;
    },
    isSeasonlyType() {
        if(this.addNewOrEditData.meetingDateType) {
            return this.addNewOrEditData.meetingDateType == '1';
        }

        if(this.addNewOrEditData.meetingBeginDate) {
            if(new Date().getFullYear() != new Date(this.addNewOrEditData.meetingBeginDate).getFullYear()
                || new Date().getMonth() != new Date(this.addNewOrEditData.meetingBeginDate).getMonth()) {
                return true;
            }
        }

        return false;
    },
    isMeCostCenter() {
        if(this.addNewOrEditData.costCenter && this.costCenterData && this.costCenterData.length > 0) {
            for (let index = 0; index < this.costCenterData.length; index++) {
                const element = this.costCenterData[index];

                if(this.addNewOrEditData.costCenter == element.costCenter && element.isMe === '1') {
                    return true;
                }
            }
        }

        return false;
    }
  },
  methods: {
    ...mapActions(['initBaseDataByTypes']),
    handleCostTypeChange(value) {
        if (value == '2') {
            // 切换到Real Wbs Code时，清空成本中心
            this.addNewOrEditData.costCenter = '';
            this.addNewOrEditData.costCenterName = '';
            this.addNewOrEditData.wbsCode = '';
            this.addNewOrEditData.wbsCodeName = '';

            if(!this.addNewOrEditData.departId || !this.addNewOrEditData.medicalField || !this.addNewOrEditData.teamL4){
                return;
            }
			costCenterAndWbs.listRealWbsCode(
                {
                    year:this.addNewOrEditData.year,
                    quarter:this.addNewOrEditData.season,
                    departId:this.addNewOrEditData.departId,
                    medicalField:this.addNewOrEditData.medicalField,
                    teamL4: this.addNewOrEditData.teamL4
                }
            )
            .then(res => {
                this.wbsCodeData = res;
            })
        } else {
            // 切换到成本中心时，清空WBS Code
            this.addNewOrEditData.wbsCode = '';
            this.addNewOrEditData.wbsCodeName = '';
            this.wbsCodeData = [];
        }
    },
    getMedicalFieldArray(departId, independ) {
      return orgUtil.franchiseArray(departId, independ);
    },
    getTeamArray(departId, medicalField, independ) {
      return orgUtil.teamArray(departId, medicalField, independ);
    },
    handleMeetingPropChange() {
        this.addNewOrEditData.meetingType='';
        this.addNewOrEditData.treatmentArea='';
        this.addNewOrEditData.diseaseArea='';
        this.addNewOrEditData.productId=[];
        this.resetRelativeFields();
    },
    handleMeetingTypeChange() {
      this.addNewOrEditData.isGsd = '';
      this.checkTotalAmount();
    },
    handleDepartChange() {
      this.addNewOrEditData.medicalField = '';
      this.addNewOrEditData.teamL4 = '';
      this.addNewOrEditData.isGsd = '';
      this.checkTotalAmount();
      this.resetRelativeFields();
    },
    checkTotalAmount() {
      if (this.disableTotalAmount) {
        this.addNewOrEditData.totalAmount = 1;
      }
    },
    handleAreaChange() {
        this.addNewOrEditData.productId=[];
        this.resetRelativeFields();
    },
    isSelectedHospitalLevel(hospitalLevelId) {
        if(hospitalLevelId == this.addNewOrEditData.hospitalLevelId) {
            return true;
        }

        if(this.addNewOrEditData.extendData.hospitalInfos) {
            for (let index = 0; index < this.addNewOrEditData.extendData.hospitalInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.hospitalInfos[index];

                if(element.hospitalLevelId == hospitalLevelId) {
                    return true;
                }
            }
        }

        return false;
    },
    isSelectedSpeakerLevel(speakerLevelId) {
        if(speakerLevelId == this.addNewOrEditData.speakerLevel) {
            return true;
        }

        if(this.addNewOrEditData.extendData.speakerInfos) {
            for (let index = 0; index < this.addNewOrEditData.extendData.speakerInfos.length; index++) {
                const element = this.addNewOrEditData.extendData.speakerInfos[index];

                if(element.speakerLevel == speakerLevelId) {
                    return true;
                }
            }
        }

        return false;
    },
    handleHospitalCountCheck() {
        if(this.meetingSystemType == 'A1' || !this.recipientSocietyOrHospital) {
           if(!this.isOneHospital() && this.moreThenOneHospital) {
                let hospitalTotalCount = this.addNewOrEditData.hospitalCount;

                this.addNewOrEditData.extendData.hospitalInfos.forEach(hs => {
                    hospitalTotalCount += hs.hospitalCount;
                })

                if(hospitalTotalCount < 2) {
                    this.$message.error(this.basedataGetName('SysErrorTip',4));
                    return false;
                }
           }
        }

        return true;
    },
    handleAmountCheck() {
        if(this.addNewOrEditData.meetingSystem.length == 2
        && this.addNewOrEditData.totalAmount > 0
        && this.addNewOrEditData.a1Amount > 0
        && this.addNewOrEditData.gsdAmount > 0
        && this.addNewOrEditData.totalAmount != this.addNewOrEditData.a1Amount + this.addNewOrEditData.gsdAmount) {
            this.$message.error(this.basedataGetName('SysErrorTip',2));
            return false;
        }

        return true;
    },
    isCEDepart() {
      return this.addNewOrEditData.departId === 'CE-OMNI' || this.addNewOrEditData.departId === 'CE-ONCO';
    },
    isOneHospital(hospitalObj) {
        return this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '科室会' ||
                this.basedataGetName('MeetingType',this.addNewOrEditData.meetingType) == '院内会';
    },
    AddNewHospitalInfo() {
        this.addNewOrEditData.extendData.hospitalInfos.push({});
    },
    removeHosiptalInfo(index) {
        this.addNewOrEditData.extendData.hospitalInfos = this.addNewOrEditData.extendData.hospitalInfos.slice(0, index).concat( this.addNewOrEditData.extendData.hospitalInfos.slice(index + 1,  this.addNewOrEditData.extendData.hospitalInfos.length));
    },
    AddNewSpeakerInfo() {
        this.addNewOrEditData.extendData.speakerInfos.push({});
    },
    removeSpeakerInfo(index) {
        this.addNewOrEditData.extendData.speakerInfos = this.addNewOrEditData.extendData.speakerInfos.slice(0, index).concat( this.addNewOrEditData.extendData.speakerInfos.slice(index + 1,  this.addNewOrEditData.extendData.speakerInfos.length));
    },
    handleMeetingOrganizerFilter(query) {
        if(!query) {
            this.remoteMeetingOrganizerData = [];
            return;
        }

        application.filterMeetingOrganizer({'name':query})
          .then(res => {
            this.remoteMeetingOrganizerData = res;
          })
    },
    handleHospitalFilter(query) {
        if(!query || (this.isOneHospital() && !this.addNewOrEditData.cityName)) {
            this.remoteHospitalData = [];
            this.remoteHospitalDataTemp = [];
            return;
        }

        let cityName = this.isOneHospital()?this.addNewOrEditData.cityName:'';

      application.filterHospital({'hospitalName' : query})
          .then(res => {
            this.remoteHospitalData = res.records;
            this.remoteHospitalDataTemp = res.records;
          })
    },
    handleCountryChange() {
      this.addNewOrEditData.countryName = this.basedataGetName('Country', this.addNewOrEditData.country)
      this.addNewOrEditData.province = '';
      this.addNewOrEditData.provinceName = '';
      this.addNewOrEditData.city = '';
      this.addNewOrEditData.cityName = '';
      this.clearHospital();
      if(this.addNewOrEditData.country) {
        basedata.listProvince({countryId:this.addNewOrEditData.country})
                .then(res => {
                  this.remoteProvinceData = res.records;
                })
      }
      else {
        this.remoteProvinceData = []
        this.remoteCitiesData = []
      }
    },
    handleProvinceChange() {
      this.addNewOrEditData.provinceName = this.getName(this.addNewOrEditData.province, this.remoteProvinceData, 'id', 'name')
      this.addNewOrEditData.city = '';
      this.addNewOrEditData.cityName = '';
      this.clearHospital();
      if(this.addNewOrEditData.province) {
        basedata.listCity({provinceId:this.addNewOrEditData.province})
                .then(res => {
                  this.remoteCitiesData = res.records;
                })
      }
      else {
        this.remoteCitiesData = []
      }
    },
    clearHospital() {
        this.addNewOrEditData.hospitalId = '';
        this.addNewOrEditData.hospitalName = '';
    },
    resetCostCenterList() {
        this.costCenterData = [];
        this.wbsCodeData = [];
        this.addNewOrEditData.costCenter = '';
        this.addNewOrEditData.wbsCode = '';
        if(!this.addNewOrEditData.departId || !this.addNewOrEditData.medicalField || !this.addNewOrEditData.teamL4){
            return;
        }

        costCenterAndWbs.listMeetingCostCenter(
            {
                departId:this.addNewOrEditData.departId,
                medicalField:this.addNewOrEditData.medicalField,
                teamL4: this.addNewOrEditData.teamL4
            }).then(res => {
                this.costCenterData = res;
            })
    },
    handleCostCenterChange() {
        this.addNewOrEditData.wbsCode = ''
        this.wbsCodeData = [];

      if(!this.addNewOrEditData.costCenter) {
          return;
      }

      costCenterAndWbs.listLocalWbsCode(
                {
                    companyCode: this.userInfo.companyCode,
                    costCenter: this.addNewOrEditData.costCenter
                }
            )
            .then(res => {
                this.wbsCodeData = res;
            })
    },
    handlerUserCostCenterFieldClick() {
        if(!this.currentUserSelectVisibled && new Date() - this.hiddenTime > 500) {
            //大于 500 毫秒才判定是手工触发
            this.$refs.costCenter.selectOption();
        }
        else {
            this.$refs.costCenter.blur();
        }
    },
    handleCostCenterSelectVisibleChange(visibled) {
        this.currentUserSelectVisibled = visibled;
        if(!this.currentUserSelectVisibled) {
            this.hiddenTime = new Date();
        }
    },
    handlerSave() {
        this.$refs['form'].validate((valid) => {
                if(valid && this.handleAmountCheck() && this.handleHospitalCountCheck()) {
                    if(this.isSeasonlyType) {
                        this.confirmSaveVisible = true;
                    }
                    else {
                        let saveData = this.getSaveData();
                        application.saveMeetingApprove(saveData)
                                .then(res => {
                                    this.monthlyTypeMessage = res;
                                    this.confirmSaveVisible = true;
                                })
                    }
                }
                else{
                    if(!valid) {
                        this.$message.error(this.basedataGetName('SysErrorTip',1));
                    }
                }
            })
    },
    getSaveData() {
        //治疗领域、疾病领域根据系统情况确定是否清空
        if(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp) != '推广') {
            this.addNewOrEditData.treatmentArea = ''
        }

        if(this.basedataGetName('MeetingProp',this.addNewOrEditData.meetingProp).indexOf('非推广') < 0) {
            this.addNewOrEditData.diseaseArea = ''
        }

        if(this.meetingSystemType == 'GSD') {
            this.addNewOrEditData.meetingType = '';
        }

        if(this.meetingSystemType == 'A1') {
            this.addNewOrEditData.meetingGsdType = '';
            this.addNewOrEditData.meetingGsdSubType = '';
        }

        //治疗领域业务结果（自定义描述）根据治疗领域业务结果是否清空
        if(this.addNewOrEditData.medicalFieldResult.join(',').indexOf('999999') < 0) {
            this.addNewOrEditData.medicalFieldResultDes = '';
        }

        //医院名称及受赠学会根据系统情况确定是否清空
        if(this.meetingSystemType == 'A1' || !this.recipientSocietyOrHospital) {
            //医院输入
            this.addNewOrEditData.recipientSocietyStr = '';
            this.addNewOrEditData.universityStr = '';
            this.addNewOrEditData.patientOrgStr = '';
            this.addNewOrEditData.otherStr = '';

            if(this.isOneHospital() || !this.moreThenOneHospital) {
                //一家医院
                this.addNewOrEditData.hospitalCount = 1;
                this.addNewOrEditData.extendData.hospitalInfos = [];
            }
            else {
                //多家医院
                this.addNewOrEditData.hospitalId = '';
                this.addNewOrEditData.hospitalName = '';

                this.addNewOrEditData.extendData.hospitalInfos.forEach(hs => {
                    hs.hospitalId = '';
                    hs.hospitalName = '';
                })
            }
        }
        else{
            //受赠输入
            this.addNewOrEditData.hospitalLevelId = '';
            this.addNewOrEditData.hospitalCount = '';
            this.addNewOrEditData.hospitalId = '';
            this.addNewOrEditData.hospitalName = '';
            this.addNewOrEditData.extendData.hospitalInfos = [];
            this.addNewOrEditData.offices = [];

            if(this.recipientSocietyOrHospital !== 1) {
                this.addNewOrEditData.recipientSocietyStr = '';
            }
            if(this.recipientSocietyOrHospital !== 2) {
                this.addNewOrEditData.universityStr = '';
            }
            if(this.recipientSocietyOrHospital !== 3) {
                this.addNewOrEditData.patientOrgStr = '';
            }
            if(this.recipientSocietyOrHospital !== 4) {
                this.addNewOrEditData.otherStr = '';
            }
        }

        //A1预算、GSD预算根据系统情况确定是否清空
        if(this.addNewOrEditData.meetingSystem.length != 2)
        {
            this.addNewOrEditData.a1Amount = 0;
            this.addNewOrEditData.gsdAmount = 0;
        }

        //是否包含讲者根据系统情况确定是否清空
        //下面代码增加讲者信息时已经处理

        let temp = _.clone(this.addNewOrEditData);


        //转换日期格式
        temp.meetingBeginDate = moment(temp.meetingBeginDate).format('YYYY-MM-DD HH:mm:ss');
        temp.meetingEndDate = moment(temp.meetingEndDate).format('YYYY-MM-DD HH:mm:ss');

        //转换多选项
        temp.companyStrategy = temp.companyStrategy.join(',');
        temp.medicalFieldResult = temp.medicalFieldResult.join(',');
        temp.meetingSystem = temp.meetingSystem.join(',');
        temp.offices = temp.offices.join(',');
        temp.productId = temp.productId.join(',');
        temp.strategyKeynote = temp.strategyKeynote.join(',');

        //转换医院信息
        temp.pubMeetingHospitalLevelList = [];
        if(this.addNewOrEditData.hospitalLevelId) {
            temp.pubMeetingHospitalLevelList.push(
                {
                    hospitalLevelId: this.addNewOrEditData.hospitalLevelId,
                    count: this.addNewOrEditData.hospitalCount,
                    hospitalId: this.addNewOrEditData.hospitalId,
                    hospitalName: this.addNewOrEditData.hospitalName,
                }
            )
        }
        temp.hospitalLevelId = '';
        temp.hospitalCount = '';
        temp.hospitalId = '';
        temp.hospitalName = '';

        this.addNewOrEditData.extendData.hospitalInfos.forEach(hospital => {
            temp.pubMeetingHospitalLevelList.push(
                {
                    hospitalLevelId: hospital.hospitalLevelId,
                    count: hospital.hospitalCount,
                    hospitalId: hospital.hospitalId,
                    hospitalName: hospital.hospitalName,
                }
            )
        })

        //转换讲者信息
        temp.pubMeetingSpeakerLevelList = [];
        if(this.addNewOrEditData.includeSpeaker) {
            temp.pubMeetingSpeakerLevelList.push(
                {
                    speakerLevel: this.addNewOrEditData.speakerLevel,
                    count: this.addNewOrEditData.speakerCount,
                }
            )
        }
        temp.speakerLevel = '';
        temp.speakerCount = '';

        if(this.addNewOrEditData.includeSpeaker) {
            this.addNewOrEditData.extendData.speakerInfos.forEach(speaker => {
                temp.pubMeetingSpeakerLevelList.push(
                    {
                        speakerLevel: speaker.speakerLevel,
                        count: speaker.speakerCount,
                    }
                )
            })
        }

        temp.extendData = '';

        return temp;
    },
    handlerSaveConfirmOK() {
        let temp = this.getSaveData();

        let funName = (this.editType == 'add' || this.editType == 'copy')?'add': 'edit';

        if(this.editType == 'add' || this.editType == 'copy') {
            delete temp.id;
        }

        application[funName](temp)
                    .then(res => {
                        let msgType = '编辑'
                        switch(this.editType) {
                            case 'add':
                                msgType = '添加';
                                break;
                            case 'copy':
                                msgType = '复制';
                                break;
                            case 'change':
                                msgType = '变更';
                                break;
                        }
                        this.$message.success(msgType+'会议成功');
                        this.waitBack = true;

                        setTimeout(() => {
                            this.$router.push({
                                name:'meetingplan-application'
                            })
                        },3000)
                    });
    },
    handleDeleteClick() {
        this.confirmDeleteVisible = true;
    },
    handlerDeleteConfirmOK() {
        application.delete({id:this.$route.params.id})
                    .then(res => {
                        this.$message.success('删除会议成功');
                        this.waitBack = true;

                        setTimeout(() => {
                            this.$router.push({
                                name:'meetingplan-application'
                            })
                        },3000)
                    });
    },
    goBack() {
        history.back();
    },
    getName(value, array, idField, nameField) {
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if(element[idField] == value) {
                return element[nameField];
            }
        }

        return '';
    },
    initCreateMeetingInfo() {
      application.getCanCreateMeeting({
        year: this.$route.params.year || this.addNewOrEditData.year,
        season: this.$route.params.season || this.addNewOrEditData.season,
      }).then(res => {
        let today = moment().format('YYYY-MM-DD');
        this.seasonStartDate = res.meetingBeginDateStart >= today?res.meetingBeginDateStart:today;
        this.seasonStartDate = new Date(this.seasonStartDate);
        this.seasonEndDate = res.meetingBeginDateEnd;
        this.seasonEndDate = new Date(this.seasonEndDate);
      });
    },
    resetRelativeFields() {
        this.addNewOrEditData.strategyKeynote = [];

        this.addNewOrEditData.speakerLevel = '';
        this.addNewOrEditData.extendData.speakerInfos.forEach(innerSpeaker => {
            innerSpeaker.speakerLevel = '';
        })

        this.addNewOrEditData.hospitalLevelId = '';
        this.addNewOrEditData.extendData.hospitalInfos.forEach(innerSpeaker => {
            innerSpeaker.hospitalLevelId = '';
        })

        this.addNewOrEditData.medicalFieldResult = [];

        this.resetCostCenterList();
    },
    filterListArray(array,valueFieldName,valueArray) {
        let _this = this;
        let resArr = valueArray.filter(function (value) {
                                    return _this.hasValue(array,valueFieldName,value);
                                });
        return resArr;
    },
    hasValue(array,valueFieldName,value) {
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if(element[valueFieldName] == value) {
                return true;
            }
        }

        return false;
    },
    init() {
        if(this.editType == 'add'){
            this.addNewOrEditData.year = this.$route.params.year;
            this.addNewOrEditData.season = this.$route.params.season;

            this.addNewOrEditData.departId = this.baseDataRecords.Depart.length>0 ? this.baseDataRecords.Depart[0].id : '';
            let tempMedicalFieldArray = this.getMedicalFieldArray(this.addNewOrEditData.departId);
            this.addNewOrEditData.medicalField = tempMedicalFieldArray.length>0 ? tempMedicalFieldArray[0].id : '';
            let tempTeamArray = this.getTeamArray(this.addNewOrEditData.departId, this.addNewOrEditData.medicalField)
            this.addNewOrEditData.teamL4 = tempTeamArray.length>0 ? tempTeamArray[0].id : '';

            this.addNewOrEditData.country = this.basedataGetIdByName('Country','中国');
            this.handleCountryChange();

            this.addNewOrEditData.includeSpeaker = 1;

            this.initCreateMeetingInfo();
            this.resetCostCenterList();
            this.addNewOrEditData.costType = '1'; // 新增默认值
        }
        else {
            application.queryById({id:this.$route.params.id})
                        .then(res => {
                            let hasOtherMedicalFieldResult = res.medicalFieldResult?res.medicalFieldResult.indexOf('999999') >= 0:false;
                            //转换多选项
                            res.companyStrategy = res.companyStrategy?res.companyStrategy.split(','):[];
                            res.medicalFieldResult = res.medicalFieldResult?res.medicalFieldResult.split(','):[];
                            res.meetingSystem = res.meetingSystem?res.meetingSystem.split(','):[];
                            res.offices = res.offices?res.offices.split(','):[];
                            res.productId = res.productId?res.productId.split(','):[];
                            res.strategyKeynote = res.strategyKeynote?res.strategyKeynote.split(','):[];

                            //新需求字段初始化
                            res.meetingGsdType = res.meetingGsdType || '';
                            res.meetingGsdSubType = res.meetingGsdSubType || '';
                            res.universityStr = res.universityStr || '';
                            res.patientOrgStr = res.patientOrgStr || '';
                            res.otherStr = res.otherStr || '';
                            res.teamL4 = res.teamL4 || '';

                            res.extendData = {
                                hospitalInfos:[],
                                speakerInfos:[],
                            };
                            res.costType = res.costType || '1'; // 如果后端返回了costType字段则使用，否则默认1

                            //设置省份、城市
                            basedata.listProvince({countryId:res.country})
                                    .then(countryRes => {
                                        this.remoteProvinceData = countryRes.records;
                                    })
                            basedata.listCity({provinceId:res.province})
                                    .then(provinceRes => {
                                        this.remoteCitiesData = provinceRes.records;
                                    })

                            //设置成本部中心、wbsCode
                            costCenterAndWbs.listMeetingCostCenter(
                                {
                                    departId:res.departId,
                                    medicalField:res.medicalField,
                                    teamL4:res.teamL4
                                }).then(res => {
                                    this.costCenterData = res;
                                })
                            if (res.costType === '1') {
                                costCenterAndWbs.listLocalWbsCode(
                                    {
                                        companyCode: this.userInfo.companyCode,
                                        costCenter: res.costCenter
                                    }
                                )
                                .then(res => {
                                    this.wbsCodeData = res;
                                })
                            }

                            if (res.costType === '2') {
                                // Real Wbs Code 模式：加载 Real Wbs Code 列表
                                if(res.departId && res.medicalField && res.teamL4) {
                                    costCenterAndWbs.listRealWbsCode({
                                        year: res.year,
                                        quarter: res.season,
                                        departId: res.departId,
                                        medicalField: res.medicalField,
                                        teamL4: res.teamL4
                                    }).then(wbsRes => {
                                        this.wbsCodeData = wbsRes || [];
                                    }).catch(err => {
                                        console.error('加载Real Wbs Code失败:', err);
                                        this.wbsCodeData = [];
                                    })
                                }
                            }

                            //模糊查询设置
                            if(res.meetingOrganizerId) {
                                this.remoteMeetingOrganizerData = [];
                                this.remoteMeetingOrganizerData.push({
                                    AD:res.meetingOrganizerName,
                                    Id:res.meetingOrganizerId,
                                    CName:res.meetingOrganizerCnname
                                })
                            }
                            if(res.pubMeetingHospitalLevelList.length > 0) {
                                this.remoteHospitalData = [];
                                this.remoteHospitalDataTemp = [];
                            }

                            //转换医院信息
                            let tempRemoteHospitalDataObj = {}
                            if(res.pubMeetingHospitalLevelList.length > 0) {
                                this.remoteHospitalData.push({
                                    hospitalName:res.pubMeetingHospitalLevelList[0].hospitalName,
                                    id: res.pubMeetingHospitalLevelList[0].hospitalId
                                })
                                this.remoteHospitalDataTemp = this.remoteHospitalData;
                                tempRemoteHospitalDataObj[res.pubMeetingHospitalLevelList[0].hospitalId] = 1;
                                res.hospitalLevelId = res.pubMeetingHospitalLevelList[0].hospitalLevelId;
                                res.hospitalCount = res.pubMeetingHospitalLevelList[0].count;
                                res.hospitalId = res.pubMeetingHospitalLevelList[0].hospitalId;
                                res.hospitalName = res.pubMeetingHospitalLevelList[0].hospitalName;
                            }
                            if(res.pubMeetingHospitalLevelList.length > 1) {
                                for (let index = 1; index < res.pubMeetingHospitalLevelList.length; index++) {
                                    const element = res.pubMeetingHospitalLevelList[index];

                                    res.extendData.hospitalInfos.push({
                                        hospitalLevelId : element.hospitalLevelId,
                                        hospitalCount : element.count,
                                        hospitalId: element.hospitalId,
                                        hospitalName : element.hospitalName,
                                    })
                                }
                            }
                            res.pubMeetingHospitalLevelList = '';

                            //转换讲者信息
                            res.includeSpeaker = res.pubMeetingSpeakerLevelList.length > 0? 1 :0;
                            if(res.pubMeetingSpeakerLevelList.length > 0) {
                                res.speakerLevel = res.pubMeetingSpeakerLevelList[0].speakerLevel;
                                res.speakerCount = res.pubMeetingSpeakerLevelList[0].count;
                            }
                            if(res.pubMeetingSpeakerLevelList.length > 1) {
                                for (let index = 1; index < res.pubMeetingSpeakerLevelList.length; index++) {
                                    const element = res.pubMeetingSpeakerLevelList[index];

                                    res.extendData.speakerInfos.push({
                                        speakerLevel : element.speakerLevel,
                                        speakerCount : element.count,
                                    })
                                }
                            }
                            res.pubMeetingSpeakerLevelList = '';

                            if(this.editType == 'copy'){
                                let today = new Date(new Date().toDateString());

                                if(res.meetingBeginDate && Date.parse(res.meetingBeginDate) < today) {
                                    res.meetingBeginDate = ''
                                }

                                if(res.meetingEndDate && Date.parse(res.meetingEndDate) < today) {
                                    res.meetingEndDate = ''
                                }
                            }

                            this.addNewOrEditData = res;

                            this.addNewOrEditData.strategyKeynote = this.filterListArray(this.filterStrategy,'id',this.addNewOrEditData.strategyKeynote);
                            this.addNewOrEditData.medicalFieldResult = this.filterListArray(this.filterDomainResult,'id',this.addNewOrEditData.medicalFieldResult)
                            if(hasOtherMedicalFieldResult) {
                                this.addNewOrEditData.medicalFieldResult.push('999999');
                            }
                            this.addNewOrEditData.hospitalLevelId = this.hasValue(this.filterHospitalLevel,'id',this.addNewOrEditData.hospitalLevelId)?this.addNewOrEditData.hospitalLevelId:'';
                            this.addNewOrEditData.extendData.hospitalInfos.forEach(hos => {
                                hos.hospitalLevelId = this.hasValue(this.filterHospitalLevel,'id',hos.hospitalLevelId)?hos.hospitalLevelId:'';
                            })
                            if(this.addNewOrEditData.includeSpeaker) {
                                this.addNewOrEditData.speakerLevel = this.hasValue(this.filterSpeakerLevel,'id',this.addNewOrEditData.speakerLevel)?this.addNewOrEditData.speakerLevel:'';
                                this.addNewOrEditData.extendData.speakerInfos.forEach(spk => {
                                    spk.speakerLevel = this.hasValue(this.filterSpeakerLevel,'id',spk.speakerLevel)?spk.speakerLevel:'';
                                })
                            }
                            if(this.addNewOrEditData.extendData.hospitalInfos.length > 0) {
                                this.recipientSocietyOrHospital = 0;
                                this.moreThenOneHospital = 1;
                            }
                            else {
                                if(this.addNewOrEditData.hospitalId || this.addNewOrEditData.hospitalCount > 0) {
                                    if(this.addNewOrEditData.hospitalCount > 1) {
                                        this.recipientSocietyOrHospital = 0;
                                        this.moreThenOneHospital = 1;
                                    }
                                    else {
                                        this.recipientSocietyOrHospital = 0;
                                        this.moreThenOneHospital = 0;
                                    }
                                }
                                else {
                                    if(this.addNewOrEditData.recipientSocietyStr) {
                                        this.recipientSocietyOrHospital = 1;
                                    }
                                    if(this.addNewOrEditData.universityStr) {
                                        this.recipientSocietyOrHospital = 2;
                                    }
                                    if(this.addNewOrEditData.patientOrgStr) {
                                        this.recipientSocietyOrHospital = 3;
                                    }
                                    if(this.addNewOrEditData.otherStr) {
                                        this.recipientSocietyOrHospital = 4;
                                    }
                                    this.moreThenOneHospital = 0;
                                }
                            }
                            this.$nextTick(() => {
                                this.remoteHospitalData = [];
                                this.remoteMeetingOrganizerData = [];
                            })

                            this.initCreateMeetingInfo();
                        })
        }
    }
  },
  mounted() {
        this.editType = this.$route.name.replace('meetingplan-application-','')

        this.initBaseDataByTypes(['MeetingModality','MeetingSystem','Depart','MedicalField','TreatmentArea','DiseaseArea','Product','CompanyStrategy','MeetingTimeInt','Country','Office','CostCenter','WbsCode','SysErrorTip','MeetingGsdType','MeetingGsdTypeSub1','MeetingGsdTypeSub2','MeetingGsdTypeSub3'])
        .then(() => {
            utils.$all([
                basedata.listStrategy(),
                basedata.listDomainResult(),
                basedata.listHospitalLevel(),
                basedata.listSpeakerLevel(),
                application.queryMeetingPropAndTypeSelect(),
                application.queryAreaRelationList({pageNo:1,pageSize:999999})
            ]).then(resList => {
                this.strategyData = resList[0].records;
                this.domainResultData = resList[1].records;
                this.hospitalLevelData = resList[2].records;
                this.hospitalLevelData.forEach(hp => {
                    this.hospitalLevelDataObject[hp.id] = hp;
                })
                this.speakerLevelData = resList[3].records;
                this.speakerLevelData.forEach(sp => {
                    this.speakerLevelDataObject[sp.id] = sp;
                })
                this.meetingPropAndTypeArrays = resList[4];
                resList[5].records.forEach(r => {
                    let areaObjectArray = this.areaRelationObject[r.meetingProp];

                    let areaObject = areaObjectArray.filter(a => a.areaDbId == r.areaDbId)[0];
                    if(!areaObject) {
                        areaObject = {
                            areaDbId: r.areaDbId,
                            areaName: r.areaName,
                            productArray: []
                        }
                        areaObjectArray.push(areaObject)
                    }

                    let productObject = areaObject.productArray.filter(p => p.productDbId == r.productDbId)[0];
                    if(!productObject) {
                        productObject = {
                            productDbId: r.productDbId,
                            productName: r.productName
                        }
                        areaObject.productArray.push(productObject)
                    }
                });
                this.init();
            })
        })
  }
};
</script>

<style lang="less" scoped>
.page-contain {

  .page-contain-tab {
    padding: 0 56px 32px 56px;
    margin-bottom: 24px;

    .recipientSocietyOrHospital-text span{
        color: @mainColor;
    }

    .recipientSociety-input {
        padding-top: 8px !important;
    }

    .more-tab {
        background: #F6F6F6;
        border-radius: 2px;
        width: 784px;
        margin-top: 8px !important;
        margin-left: -16px !important;
        padding-left: 16px !important;
        padding-top: 16px !important;
        padding-bottom: 12px !important;
    }

    .more-tab-div{
        margin-top: 16px;
    }
  }
}

.bottom-info {
    display: flex;
    position: fixed;
    background-color: #fff;
    width: 100%;
    left: 0;
    height: 44px;
    box-shadow: -1px 0px 4px 0px rgba(51,51,51,0.35);
    bottom: 0;
    z-index: 1000;

    &-info {
      margin-left: 120px;
      line-height: 44px;
    }

    &-operate {
      position: absolute;
      right: 120px;
      line-height: 46px;
    }
  }

  .meeting-place-tip {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    white-space: nowrap;
  }

  .col-add-remove {
      display: flex;
  }

  .operate-add-remove {
    display: flex;
    font-size: 20px;
    margin: 38px 0px 0px 10px;

    .icon-tianjia1 {
        color: #008748;
    }
    .icon-shanjian {
        color: #E40030;
    }

    i {
        cursor: pointer;
        height: 42px;
        line-height: 42px;
    }

    i + i {
        margin-left: 10px;
    }
  }


    .edit-meeting-plan {
        padding: 0;
        margin-bottom: 85px;

        .edit-form-title {
            padding: 26px 0 0 34px;
            color: #0066CC;
            font-size: @subFontSize;
            display: block;
        }

        .el-form.el-form--label-top{
            .el-row {
            padding: 24px 0 0 0;

            .col-full {
                width: 1088px;

                .el-input__inner {
                width: 1088px;
                }

                .el-textarea__inner {
                height: 110px;
                }

                .el-form-item__label {
                height: 24px;
                line-height: 24px;
                color: @contentFontColor;
                font-size: @contentFontSize;
                }

                .el-form-item__content {
                    padding-top: 2px;
                    .el-select, .el-input, .el-input-number {
                        width: 320px;
                    }
                }
            }

            .el-col {
                width: 320px;

                .el-form-item__label {
                height: 24px;
                line-height: 24px;
                color: @contentFontColor;
                font-size: @contentFontSize;
                }

                .el-form-item__content {
                    padding-top: 2px;

                    .el-select, .el-input, .el-input-number {
                        width: 320px;
                    }
                }
            }

            .el-col  + .el-col {
                margin-left: 64px;
            }
            }

            .col-no-3 {
                margin-left: 768px;
            }
        }

        .el-form.el-form--label-right{
            .el-row {
            padding: 21px 34px 0 34px;
            }
        }
    }
</style>
<style lang="less">
.edit-main {
    .common-confirm-info {
        div + div {
            margin-top: 5px !important;
            line-height: 24px;
            padding: 0 20px;
        }
    }

    .content-box {
        .medicalFieldResultDesItem .el-form-item__content {
            line-height: 0px;
            margin-top: 1px;
        }
        .medicalFieldResultDes textarea{
            height: 32px;
        }

        .cost-center-col {
            position: relative;

            .user-cost-center-field {
                position: absolute;
                z-index: 1;
                font-size: 14px;
                background-color: #fff;
                height: 28px;
                line-height: 30px;
                bottom: 8px;
                left: 16px;
                width: 274px;
                cursor: pointer;

                &-label {
                    width: 220px;
                    overflow: hidden;
                    display: inline-block;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
            }
        }
    }
}

.edit-main-cost-center, .edit-meeting-plan {
    .current-user {
            float: right;
            display: block;
            color: #fff;
            width: 40px;
            height: 24px;
            background: #0066CC;
            border-radius: 12px;
            text-align: center;
            line-height: 24px;
            margin-top: 5px;
        }
}

.edit-meeting-plan {
    .current-user {
            margin-top: 3px !important;
        }

}
</style>



// WEBPACK FOOTER //
// index.vue?f3350500